/* __next_internal_client_entry_do_not_use__ TransparencyOverlay auto */ import { Core } from "@faire/design-tokens";
import styled from "styled-components";
export var TransparencyOverlay = styled.div.withConfig({
    componentId: "sc-85ac0baa-0"
})([
    "width:100%;height:100%;position:absolute;background:",
    "05;left:0;top:0;z-index:2;pointer-events:none;"
], function(props) {
    var _props_color;
    return (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : Core.surface.enabled;
});
